import { Col, DatePicker, Form, Input, InputNumber, Row, Select, Slider, Space } from "antd";
import styles from "./FormInfo.module.css";
import classNames from "classnames/bind";
import { DownIcons } from "../Icons/Icons";
import TextArea from "antd/es/input/TextArea";
import { Fragment } from "react";
const cx = classNames.bind(styles);

function FormInfo({ form, listInfo = [], gutter = [8, 8], formItemProps = {}, direction = "vertical", directionProps = {} }) {
    const Direction = direction === "vertical" ? Fragment : Space;
    const render = (formItem) => {
        const { hide, type, label, span, ...props } = formItem;
        if (hide) {
            return <></>
        } else {
            switch (type) {
                case 'input':
                    return (
                        <Input
                            className={cx("info-item", "input")}
                            {...props}
                        />
                    )
                case 'inputNumber':
                    return (
                        <InputNumber
                            className={cx("info-item", "input", `${props?.align}`)}
                            {...props}
                            type="number"
                        />
                    )
                case 'textArea':
                    return (
                        <TextArea
                            className={cx("info-item", "input")}
                            {...props}
                        />
                    )
                case 'select':
                    return (
                        <Select
                            className={cx("info-item", "select")}
                            {...props}
                            placeholder={"Tất cả"}
                            // notFoundContent={<></>}
                            suffixIcon={<DownIcons />}
                        />
                    )
                case 'autocomplete':
                    return (
                        <Select
                            className={cx("info-item", "select")}
                            {...props}
                            placeholder={"Tất cả"}
                            // notFoundContent={<></>}
                            suffixIcon={<DownIcons />}
                        />
                    )
                case 'datepicker':
                    return (
                        <DatePicker
                            className={cx("info-item", "datepicker")}
                            {...props}
                        />
                    )
                case 'slider':
                    return (
                        <Slider
                            className={cx("info-item", "slider")}
                            {...props}
                            tooltip={{ open: true }}
                        />
                    )
                default:
                    return <></>;
            }
        }
    }
    return (
        <Form form={form}>
            <Row gutter={gutter}>
                {listInfo?.map((formItem, index) => {
                    return (
                        <Col span={formItem?.hide ? 0 : formItem?.span} key={`${formItem?.name}_${index}`} >
                            <Direction {...directionProps}>
                                {!formItem?.hide && <p className={cx("label")}>{formItem?.label}</p>}
                                {!formItem?.hide ? (
                                    <Form.Item
                                        name={formItem?.name}
                                        rules={formItem?.rules}
                                        {...formItemProps}
                                    >
                                        {render(formItem)}
                                    </Form.Item>
                                ) : (
                                    <></>
                                )}
                            </Direction>
                        </Col>
                    )
                })}
            </Row>
        </Form>
    )
}

export default FormInfo;